window.apisExactExportPaymentConditionsDetailFormatter = function(value, row) {
    let html = '';
    let data = JSON.parse(row.data);
    if (data != null && Object.keys(data).length > 0) {
        html += '<div class="form-group">';
        html += "<label>"+__('Response')+"</label>";
        html += '<textarea class="form-control" rows="3">'+row.data+"</textarea>";
        html += '</div>';
        html += '<div class="mt-3"></div>';
        html += '<table class="table table-borderless table-hover table-responsive table-sm table-striped text-nowrap">';
        html += '<thead>';
        html += '<tr>';
        html += '<th>'+__('Code')+'</th>';
        html += '<th>'+__('Description')+'</th>';
        html += '<th>'+__('Payment Days')+'</th>';
        html += '<th>'+__('Payment Method')+'</th>';
        html += '</tr>';
        html += '</thead>';
        html += '<tbody>';
        data.sort((a, b) => a.Code.localeCompare(b.Code));
        for (let i = 0; i < data.length; i++) {
            let paymentCondition = data[i];
            html += '<tr>';
            html += '<td>'+paymentCondition.Code+'</td>';
            html += '<td>'+paymentCondition.Description+'</td>';
            html += '<td>'+paymentCondition.PaymentDays+'</td>';
            html += '<td>';
            html += paymentCondition.PaymentMethod+' &rarr; ';
            switch (paymentCondition.PaymentMethod) {
                case 'B':
                    html += __('On credit');
                    break;
                case 'I':
                    html += __('Collection');
                    break;
                case 'K':
                    html += __('Cash');
                    break;
                case 'Q':
                    html += __('PSP Collection');
                    break;
            }
            html += '</td>';
            html += '</tr>';
        }
        html += '</tbody>';
        html += '</table>';
    }
    return html;
};

